// import React from 'react'
// import s1 from "../assets/s1.png";
// import wp1 from "../assets/wp1.png";
// import wp2 from "../assets/wp2.png";
// import wp3 from "../assets/wp3.png"; 
// import wp4 from "../assets/wp4.png"; 

// const BusinessLegal = () => {
//   const data = [
//     {
//       title: "Financial Inclusion",
//       text: "Brings banking to remote or rural areas without branches."
//     },
//     {
//       title: "Secure & Reliable",
//       text: "Uses Aadhaar authentication, reducing fraud risk."
//     },
//     {
//       title: "No Card Required",
//       text: "Works without debit/credit cards or smartphones in some cases."
//     },
    
//   ];
//   return (
//     <>
//        <div className="container-fluid">
//         <div
//           className="text-center top-heading section" 
//         >
//           <h1>Business & Legal Registration</h1>
//         </div>
//       </div>
//       <div className="container">
//          <div className="row section align-items-center">
//           <div className="col-12 col-md-6 mb-3 mb-md-0">
//             <h1>
//               <strong>Overview</strong>
//             </h1>
//           </div>

//           <div className="col-12 col-md-6">
//             <p>
//               <strong style={{ color: "#FF7A60", fontSize: "26px" }}>O</strong>
//               ur platform supports digital payments via UPI along with cash
//               access through Micro ATMs — giving customers flexibility to go
//               cashless or withdraw cash conveniently. Based on PaymentHub’s
//               service model
//             </p>
//           </div>
//         </div>

//         <div className="section">
//           <img src={s1} className="w-100" />
//         </div>      

//           <div className="row g-4 justify-content-center text-center">
//              <h2 className='mt-4 mb-5' style={{textAlign:"center",fontWeight:"600"}}>What We Provide</h2>
//         {/* GST / MSME Registration */}
//         <div className="col-12 col-sm-6 col-md-6 col-lg-3">
//           <div className="p-4 h-100 rounded-4" style={{ backgroundColor: "#FFDED3" }}>
//             <img src={wp1} alt="GST/MSME Registration" className="mb-3 img-fluid" />
//             <h5 className="fw-semibold">GST / MSME (Udyam) Registration.</h5>
//             <p>GST registration & return filing <br /> paymenthub</p>
//           </div>
//         </div>

//         {/* FSSAI License Registration */}
//         <div className="col-12 col-sm-6 col-md-6 col-lg-3">
//           <div className="p-4 h-100 rounded-4" style={{ backgroundColor: "#E0FBFF" }}>
//             <img src={wp2} alt="FSSAI License Registration" className="mb-3 img-fluid" />
//             <h5 className="fw-semibold">FSSAI License Registration.</h5>
//             <p>Income tax return (ITR) filing <br /> paymenthub.</p>
//           </div>
//         </div>

//         {/* Trademark Filing */}
//         <div className="col-12 col-sm-6 col-md-6 col-lg-3">
//           <div className="p-4 h-100 rounded-4" style={{ backgroundColor: "#EBF4E7" }}>
//             <img src={wp3} alt="Trademark Filing" className="mb-3 img-fluid" />
//             <h5 className="fw-semibold">Trademark Filing</h5>
//             <p>Set up, manage, and maintain your <br /> infrastructure.</p>
//           </div>
//         </div>

//         {/* Company Formation */}
//         <div className="col-12 col-sm-6 col-md-6 col-lg-3">
//           <div className="p-4 h-100 rounded-4" style={{ backgroundColor: "#FFEDD3" }}>
//             <img src={wp4} alt="Company Formation" className="mb-3 img-fluid" />
//             <h5 className="fw-semibold">
//               Company Formation (Pvt. Ltd, Ltd, NGO, Trust)
//             </h5>
//             <p>Set up, manage, and maintain your <br /> infrastructure.</p>
//           </div>
//         </div>
//       </div>

//          {/* benefits */}
//        <div className="section d-none d-md-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="benefits-wrapper position-relative">
//             <div className="benefit"></div>
//             <div className="center-line"></div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">Professional help to navigate legal processes.</h5>
//                   <p className="text-start">
// One-stop bill payment portal for multiple services.                  </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6"></div>
//               <div className="col-6">
//                 <div className="benefit-card-1">
//                   <h5 className="fw-bold mb-3">Saves time and cost with expert support..</h5>
//                   <p>Backed by established payment network.</p>
//                 </div>
//               </div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">Affordable service suited for small businesses, retailers, or agents.</h5>
//                   <p className="text-start">
//                     Agents can facilitate bill payments and earn fees. (Modelled like PaymentHub)
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>
//           </div>
//         </div>
//         <div className="section d-md-none d-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="row justify-content-center">
//             {data.map((item, index) => (
//               <div className="col-12 mb-3" key={index}>
//                 <div className="benefit-box text-center p-4">
//                   <h5 className="mb-2" style={{fontWeight:"700"}}>{item.title}</h5>
//                   <p className="mb-0">{item.text}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default BusinessLegal
import React from "react";
import s1 from "../assets/s1.png";
import solution from "../assets/solution.png";
import solution1 from "../assets/exchange.png";
import solution2 from "../assets/neural.png";
import solution3 from "../assets/cash-withdrawal.png";
import solution4 from "../assets/files.png";
import solution5 from "../assets/shield.png";
import PhoneHeader from "./PhoneHeader";

const BusinessLegal = () => {
  return (
    <>
      <PhoneHeader title="AEPS Service" className="d-md-none d-block" />

      {/* <div className="container-fluid d-md-block d-none">
        <div className="text-center top-heading section">
          <h1>AEPS Service</h1>
        </div>
      </div> */}
      <div className="container">
        <div className="text-center top-heading section">
          <h1 className="mb-0">Registration Services</h1>
        </div>
        <div className="row section align-items-center">
          <div className="col-12 col-md-7">
            <div className="">
              <h1>
                <strong>Overview</strong>
              </h1>
            </div>
            <p>
              {/* <strong style={{ color: "#FF7A60", fontSize: "26px" }}>O</strong> */}
             Our Registration Services are designed to help individuals, shop owners, and businesses easily complete essential government and financial registrations required to operate in today’s digital economy. Whether you are an AEPS retailer, distributor, or small entrepreneur, we provide fast, reliable, and fully guided registration support to help you start and grow your business without hassle.
            </p>
          </div>
          <div className="col-12 col-md-5 mb-3 mb-md-0">
            <div className="">
              <img src={s1} className="w-100 m-auto img-holl" />
            </div>
          </div>
        </div>

      <div
          className="row section p-md-4 px-1 pt-5 pb-4"
          style={{ backgroundColor: "#FFF6F3"}}
        >
          {/* <div className="col-12">
            <h2 className="mb-5 center" style={{ fontWeight: "700" }}>
              Why Choose Our AEPS Solution
            </h2>
          </div> */}

          <div className="col-12 col-md-6 m-auto">
            <img src={solution} />
          </div>

          <div className="col-12 col-md-6 m-auto ">
            <h2 className="mb-md-5 mb-4 center" style={{ fontWeight: "700" }}>
              Why Choose Our Registration Services?
            </h2>
            <div className="solution-icon">
              <div className="m-auto solution-icon-1">
                <img src={solution1} />
              </div>
              <div className="solution-icon-2 gap-3">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                 Fast & Hassle-Free Processing
                </h6>
                <p className="mb-0">
                 We manage the documentation and submission so you can focus on your business.
                </p>
              </div>
            </div>

            <div className="solution-icon">
              <div className="m-auto solution-icon-1">
                <img src={solution2} />
              </div>
              <div className="solution-icon-2 gap-3">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Affordable for Small Businesses
                </h6>
                <p className="mb-0">
                  Designed especially for AEPS retailers, shopkeepers, and startups.
                </p>
              </div>
            </div>

            <div className="solution-icon">
              <div className="m-auto solution-icon-1">
                <img src={solution3} />
              </div>
              <div className="solution-icon-2 gap-3">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Expert Guidance at Every Step
                </h6>
                <p className="mb-0">
                 Our team ensures 100% accuracy to avoid delays or rejections.
                </p>
              </div>
            </div>

            <div className="solution-icon">
              <div className="m-auto solution-icon-1">
              <img src={solution4} />
              </div>
              <div className="solution-icon-2 gap-3">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Secure & Confidential Handling
                </h6>
                <p className="mb-0">
                   Your documents and business data are handled with the highest privacy standards.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center g-4 section">
          <h2
            className="mt-4 mb-5"
            style={{ textAlign: "center", fontWeight: "600" }}
          >
           What We Offer
          </h2>
          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#FFDED3" }}
            >
              {/* <img
                src={so1}
                alt="Software Development"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">
                GST Registration
              </h5>
              <p className="mt-2 flex-grow-1">
              Get your business registered under the Goods and Services Tax (GST) system quickly and accurately. Our team assists with documentation, submission, and approval to ensure smooth compliance.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#E0FBFF" }}
            >
              {/* <img
                src={so2}
                alt="Hardware Support"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">Udyam (MSME) Registration</h5>
              <p className="mt-2 flex-grow-1">
               We help small and medium enterprises register under the MSME scheme to access government benefits, subsidies, and loan support.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">PAN & TAN Registration</h5>
              <p className="mt-2 flex-grow-1">
                Whether you need a new PAN, corrections, or TAN for tax-related activities, our experts provide end-to-end support for fast and error-free processing.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#E0FBFF" }}
            >
              {/* <img
                src={so1}
                alt="Software Development"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">Shop & Establishment Registration
</h5>
              <p className="mt-2 flex-grow-1">
                Comply with state business laws easily. We handle the entire registration process for shops, offices, and commercial establishments.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              {/* <img
                src={so2}
                alt="Hardware Support"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">FSSAI Registration</h5>
              <p className="mt-2 flex-grow-1">
               For businesses dealing in food products, we provide hassle-free registration under the FSSAI for legal and safe operations.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#FFDED3" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">
                Digital Payment & Fintech Service Registration
              </h5>
              <p className="mt-2 flex-grow-1">
                We assist AEPS retailers, distributors, and fintech partners with:
              </p>
              {/* <ul class="list-unstyled">
              <li class="mb-2">
                • AEPS service activation
              </li>
              <li class="mb-2">
                • UPI & BBPS registration
              </li>
              <li class="mb-2">
                • Wallet and KYC approvals
              </li>
              <li class="mb-2">• Business onboarding and documentation </li>
            </ul> */}
            </div>
          </div>
        </div>

        <div className="section key-features align-items-center py-5 py-md-5 p-4">
          {/* HEADING */}
          <h2 className="fw-bold text-center mb-4">Registration Services Are Ideal For </h2>

          <div className="row">
            {/* IMAGE */}
            <div className="col-12 col-md-5  text-center mb-4 mb-md-0">
              <img
                src={s1}
                alt="Key Features"
                className="img-fluid img-holl"
                style={{ maxWidth: "100%" , width: "100%"}}
              />
            </div>

            {/* FEATURE LIST */}
            <div className="col-12 col-md-7">
              <ul
                className="list-unstyled mx-auto"
              >
                <li className=" mb-3">• AEPS retailers & distributors</li>
                <li className=" mb-3">• CSC and fintech operators </li>
                <li className=" mb-3">• Small businesses & startups</li>
                <li className=" mb-3">• Shop owners</li>
                <li className="mb-3">• Freelancers & service providers</li>
                <li className="mb-3">• Individuals needing quick and easy registration support</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessLegal;
